const Container = ({ children }) => {
  return <div className="max-w-[1680px] px-[1.5rem] m-auto">{children}</div>;
};

export default Container;
